import { compose, hoistStatics, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { settingsActions } from '../../reducers/settings';
import Main from './Main';
import WithLoading from '../../components/WithLoading';
import SettingsService from '../../services/company.service';
import SubscriberService from '../../services/subscriber.service';
import api from '../../services/api.service';
import Loading2 from '../../components/Loading2';
import ModuleService from '../../services/module.service';
import AuthService from '../../services/auth.service';

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
  setSocialAuth: settingsActions.setSocialAuth,
};

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const findGetParameter = (parameterName) => {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach((item) => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

const mapStateToProps = state => ({
  show2faPages: state.settings.show2faPages,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showRoutes', 'setShowRoutes', false),
  withState('isLoading', 'setIsLoading', true),
  withState('subscriber', 'setSubscriber', null),
  lifecycle({
    async componentDidMount() {
      const { props } = this;
      const { subscriber, redirect } = await SettingsService.get();

      const socialAuth = await ModuleService.getSocial();
      props.setSocialAuth(socialAuth);

      if (subscriber.default_route) {
        await props.updateSettings({ subscriber, defaultRoute: subscriber.default_route });
      } else {
        await props.updateSettings({ subscriber });
      }

      if (subscriber) {
        api.subdomain = subscriber.name;
      } else if (redirect) {
        window.location.href = redirect + window.location.pathname;
      }
      await props.setSubscriber(subscriber);
      const { colors: customColors, customCss, customJs } = await SubscriberService.colors();
      props.updateSettings({ customColors, customCss, customJs });
      await sleep(400);

      if (window.location.pathname === '/login') {
        const paramEmail = findGetParameter('email');
        if (paramEmail) {
          const isTeam = await AuthService.checkIsTeam(paramEmail);
          if (isTeam && isTeam.result) window.location.href = `https://${window.location.host}/admin`;
        }
      }
      await props.setShowRoutes(!!subscriber);
      props.setIsLoading(false);
    },
  }),
);

export default hoistStatics(enhance)(WithLoading(Main, Loading2));



// WEBPACK FOOTER //
// ./src/containers/main/index.js